import React, { useState } from "react";

import withStyles from "@mui/styles/withStyles";
import Slide from "@mui/material/Slide";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

import Close from "@mui/icons-material/Close";
import Button from "components/CustomButtons/Button";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import CustomDatetimeAdapter from "../components/CustomDatetimeAdapter";
import CustomInputAdapter from "../components/CustomInputAdapter";
import CustomDropdownAdapter from "customComponents/CustomDropdownAdapter/CustomDropdownAdapter";
import LocationModal from "../LocationModal";

import modalStyle from "assets/jss/material-kit-pro-react/modalStyle";
import PropTypes from "prop-types";
import { Form } from "react-final-form";
import arrayMutators from "final-form-arrays";
import FieldAdapter from "../components/FieldAdapter";

import ImageSelectAdapter from "../components/ImageSelectAdapter";
import EditorAdapter from "../components/EditorAdapter";
import { getImageURL } from "utils/Utils";

const style = (theme) => ({
    ...modalStyle(theme),
    modalRootExample: {
        "& > div:first-child": {
            display: "none",
        },
        backgroundColor: "rgba(0, 0, 0, 0.5)",
    },
    removeButton: {
        display: "flex",
        justifyContent: "flex-end",
    },
});

const Transition = React.forwardRef((props, ref) => (
    <Slide direction="down" ref={ref} {...props} />
));

const EventModal = (props) => {
    const [open, setOpen] = useState(false);
    const [event, setEvent] = useState();
    const [imageURI, setImageURI] = useState();

    const {
        classes,
        button,
        event: initialEvent,
        onSubmit: handleSubmitProp,
        locations,
        createLocation,
    } = props;


    const onSubmit = async (values) => {
        const { imageFile, ...eventData } = values;
        handleSubmitProp(eventData, imageFile);
        handleClose();
    };

    const handleClickOpen = async () => {
        setEvent({ ...initialEvent, description: initialEvent ? initialEvent.descriptionAsHtml : "" });
        if (initialEvent && initialEvent.image) setImageURI(initialEvent.image);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };


    return (
        <div>
            <div onClick={() => handleClickOpen()}>{button}</div>
            {open && (
                <Dialog
                    classes={{
                        root: `${classes.modalRoot} ${classes.modalRootExample}`,
                        paper: `${classes.modal} ${classes.modalLarge}`,
                    }}
                    open={open}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={() => handleClose("scrollingModal")}
                    aria-labelledby="classic-modal-slide-title"
                    aria-describedby="classic-modal-slide-description"
                >
                    <Form
                        onSubmit={onSubmit}
                        initialValues={event}
                        mutators={{ ...arrayMutators }}
                        render={({ handleSubmit, form, submitting, pristine, values }) => (
                            <form onSubmit={handleSubmit}>
                                <DialogTitle
                                    id="classic-modal-slide-title"
                                    className={classes.modalHeader}
                                >
                                    <Button
                                        simple
                                        className={classes.modalCloseButton}
                                        key="close"
                                        aria-label="Close"
                                        onClick={() => handleClose("scrollingModal")}
                                    >
                                        {" "}
                                        <Close className={classes.modalClose} />
                                    </Button>
                                    <h4 className={classes.modalTitle}>
                                        {values.name ? values.name : "Neue Veranstaltung"}
                                    </h4>
                                </DialogTitle>
                                <DialogContent
                                    id="classic-modal-slide-description"
                                    className={classes.modalBody}
                                >
                                    <GridContainer>
                                        <GridItem>
                                            <FieldAdapter
                                                name="imageFile"
                                                component={ImageSelectAdapter}
                                                type="file"
                                                id="imageFile"
                                                imagePath={imageURI}
                                            />
                                        </GridItem>
                                        <GridItem>
                                            <FieldAdapter
                                                name="name"
                                                component={CustomInputAdapter}
                                                type="text"
                                                placeholder="Name"
                                                label="Name"
                                                validate={(value) => !value && "Eingabe erforderlich"}
                                            />
                                        </GridItem>
                                        <GridItem>
                                            <FieldAdapter
                                                name="tagline"
                                                component={CustomInputAdapter}
                                                type="text"
                                                placeholder="Tagline"
                                                label="Tagline"
                                                inputProps={{
                                                    multiline: true,
                                                    maxRows: 10,
                                                }}
                                            />
                                        </GridItem>
                                        <GridItem>
                                            <FieldAdapter
                                                name="description"
                                                component={EditorAdapter}
                                                label="Beschreibung"
                                                id="description"
                                            />
                                        </GridItem>
                                        <GridItem>
                                            <FieldAdapter
                                                name="details"
                                                component={CustomInputAdapter}
                                                type="text"
                                                placeholder="Details"
                                                label="Details"
                                                inputProps={{
                                                    multiline: true,
                                                    maxRows: 10,
                                                }}
                                            />
                                        </GridItem>

                                        <GridItem xs={12} sm={6} md={6} lg={6}>
                                            <h4>Datum</h4>
                                        </GridItem>
                                        <GridItem xs={12}>
                                            <GridContainer>
                                                <GridItem xs={6} sm={6} md={6} lg={6}>
                                                    <FieldAdapter
                                                        name={"schedule.from"}
                                                        component={CustomDatetimeAdapter}
                                                        label="Start"
                                                        dateFormat={"YYYY-MM-DD"}
                                                        timeFormat={false}
                                                        validate={(value) => {
                                                            const match = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
                                                            if (!value) {
                                                                return "Eingabe erforderlich";
                                                            } else if (!match.test(value)) {
                                                                return "Datum muss das Format YYYY-MM-DD haben";
                                                            }
                                                        }}
                                                    />
                                                </GridItem>
                                                <GridItem xs={6} sm={6} md={6} lg={6}>
                                                    <FieldAdapter
                                                        name={"schedule.to"}
                                                        component={CustomDatetimeAdapter}
                                                        label="Ende"
                                                        dateFormat={"YYYY-MM-DD"}
                                                        timeFormat={false}
                                                        validate={(value) => {
                                                          const match = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
                                                          if (!value) {
                                                              return "Eingabe erforderlich";
                                                          } else if (!match.test(value)) {
                                                              return "Datum muss das Format YYYY-MM-DD haben";
                                                          }
                                                          if (values.schedule?.from && value && value < values.schedule.from) {
                                                              return "Enddatum muss nach dem Startdatum liegen";
                                                          }
                                                        }}
                                                    />
                                                </GridItem>
                                            </GridContainer>
                                        </GridItem>

                                        <GridItem xs={12} sm={6} md={6} lg={6}>
                                            <h4>Sportstätte</h4>
                                        </GridItem>
                                        <GridItem xs={12} sm={6} md={6} lg={6}>
                                            <LocationModal
                                                onSubmit={createLocation}
                                                button={(onClick) => {
                                                    return (
                                                        <Button
                                                            color="primary"
                                                            simple
                                                            onClick={() => onClick()}
                                                        >
                                                            <i className="fas fa-plus" /> Neue Sportstätte
                                                        </Button>
                                                    );
                                                }}
                                            />
                                        </GridItem>
                                        <GridItem xs={12}>
                                            <FieldAdapter
                                                name="location"
                                                component={CustomDropdownAdapter}
                                                type="text"
                                                label="Sportstätte auswählen"
                                                placeholder="Sportstätte auswählen"
                                                dropDownList={(locations || [])
                                                    .filter((item) => item && item.name)
                                                    .sort((a, b) => a.name.localeCompare(b.name))}
                                                id="location"
                                                getKey={(item) => item?.id}
                                                getValue={(item) => item}
                                                getName={(item) => item?.name}
                                            />
                                        </GridItem>

                                    </GridContainer>
                                </DialogContent>
                                <DialogActions className={classes.modalFooter}>
                                    <Button
                                        onClick={form.reset}
                                        disabled={submitting || pristine}
                                        color="secondary"
                                    >
                                        Zurücksetzen
                                    </Button>
                                    <Button color="primary" type="submit" disabled={submitting}>
                                        Speichern
                                    </Button>
                                </DialogActions>
                            </form>
                        )}
                    />
                </Dialog>
            )}
        </div>
    );
};

EventModal.propTypes = {
    classes: PropTypes.object,
    event: PropTypes.object,
    onSubmit: PropTypes.func.isRequired,
    button: PropTypes.node,
    locations: PropTypes.array,
    createLocation: PropTypes.func,
};

EventModal.defaultProps = {
    locations: [],
    event: {},
};

export default withStyles(style)(EventModal);